"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeNotification = exports.setNotification = exports.REMOVE_NOTIFICATION = exports.SET_NOTIFICATION = void 0;
exports.SET_NOTIFICATION = 'SET_NOTIFICATION';
exports.REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
const setNotification = ({ message, feature }) => ({
    type: `${feature} ${exports.SET_NOTIFICATION}`,
    payload: message,
    meta: { feature },
});
exports.setNotification = setNotification;
const removeNotification = ({ notificationId, feature }) => ({
    type: `${feature} ${exports.REMOVE_NOTIFICATION}`,
    payload: notificationId,
    meta: { feature },
});
exports.removeNotification = removeNotification;
//# sourceMappingURL=notification.js.map